import { NgModule } from '@angular/core';
import { DebugService } from '@core/services/debug/debug.service';
import {
  PalantirAccordionComponent,
  PalantirAvatarComponent,
  PalantirAvatarGroupComponent,
  PalantirBadgeComponent,
  PalantirBreadcrumbsComponent,
  PalantirButtonComponent,
  PalantirCheckboxComponent,
  PalantirContentComponent,
  PalantirDropdownMenuModule,
  PalantirEmptyStateComponent,
  PalantirIconComponent,
  PalantirInputComponent,
  PalantirLayoutComponent,
  PalantirListItemComponent,
  PalantirModalComponent,
  PalantirPageComponent,
  PalantirPaginationComponent,
  PalantirRadioComponent,
  PalantirSelectComponent,
  PalantirSkeletonComponent,
  PalantirTabsModule,
  PalantirTagComponent,
  PalantirTextComponent,
  PalantirToolbarComponent,
  PalantirTooltipModule,
  PalantirTableComponent,
  PalantirCardComponent,
  PalantirProgressComponent,
  PalantirDialogComponent,
} from '@flux/design-system';

@NgModule({
  declarations: [],
  imports: [
    PalantirDropdownMenuModule,
    PalantirPageComponent,
    PalantirToolbarComponent,
    PalantirAvatarComponent,
    PalantirIconComponent,
    PalantirTextComponent,
    PalantirButtonComponent,
    PalantirEmptyStateComponent,
    PalantirPaginationComponent,
    PalantirModalComponent,
    PalantirContentComponent,
    PalantirLayoutComponent,
    PalantirInputComponent,
    PalantirTagComponent,
    PalantirCheckboxComponent,
    PalantirRadioComponent,
    PalantirDialogComponent,
    PalantirModalComponent,
    PalantirSelectComponent,
    PalantirBreadcrumbsComponent,
    PalantirAccordionComponent,
    PalantirSkeletonComponent,
    PalantirBadgeComponent,
    PalantirListItemComponent,
    PalantirAvatarGroupComponent,
    PalantirTooltipModule,
    PalantirTabsModule,
    PalantirTableComponent,
    PalantirCardComponent,
    PalantirProgressComponent,
  ],
  exports: [
    PalantirDropdownMenuModule,
    PalantirPageComponent,
    PalantirToolbarComponent,
    PalantirAvatarComponent,
    PalantirIconComponent,
    PalantirTextComponent,
    PalantirButtonComponent,
    PalantirEmptyStateComponent,
    PalantirPaginationComponent,
    PalantirModalComponent,
    PalantirContentComponent,
    PalantirInputComponent,
    PalantirLayoutComponent,
    PalantirTagComponent,
    PalantirModalComponent,
    PalantirCheckboxComponent,
    PalantirRadioComponent,
    PalantirSelectComponent,
    PalantirBreadcrumbsComponent,
    PalantirAccordionComponent,
    PalantirSkeletonComponent,
    PalantirBadgeComponent,
    PalantirListItemComponent,
    PalantirAvatarGroupComponent,
    PalantirTooltipModule,
    PalantirDialogComponent,
    PalantirTabsModule,
    PalantirTableComponent,
    PalantirCardComponent,
    PalantirProgressComponent,
  ],
  providers: [DebugService],
})
export class PalantirSharedModule {}
